module.exports = __webpack_public_path__ + "assets/img/typeIcon-4-blue.5d9da29a.svg";